import React, { useEffect, useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

// importing aos
import "aos/dist/aos.css";
//GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

gsap.registerPlugin(ScrollTrigger);

export const PublicHome = () => {
  let timer;
  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      timer = setInterval(() => {
        openPopUp();
      }, 5000);
      firstRender.current = false;
    }
  });

  const nav = useNavigate();
  const main = useRef();
  const tga1 = useRef();
  const steps = useRef();
  const service = useRef();

  function openPopUp() {
    clearInterval(timer);
    let pop = document.getElementById("pop");
    let popO = document.getElementById("popO");
    popO.style.display = "block";
    pop.style.display = "block";
    setTimeout(() => {
      popO.style.opacity = "1";
      pop.style.opacity = "1";
    }, 200);
  }

  function closePopUp() {
    let pop = document.getElementById("pop");
    let popO = document.getElementById("popO");
    popO.style.opacity = "0";
    pop.style.opacity = "0";
    setTimeout(() => {
      popO.style.display = "none";
      pop.style.display = "none";
    }, 200);
  }

  useLayoutEffect(() => {
    const ctx = gsap.context((self) => {
      gsap.from(".grid-elem", {
        opacity: "0",
        ease: "Power3.easeOut",
        y: 100,
        stagger: 0.2,
        duration: 1,
        scrollTrigger: {
          trigger: ".grid-elem",
        },
      });
    }, main); // <- Scope!
    return () => ctx.revert(); // <- Cleanup!
  }, []);

  useLayoutEffect(() => {
    const ctx = gsap.context((self) => {
      gsap.from(".tga1", {
        opacity: "0",
        ease: "Power3.easeOut",
        y: 100,
        stagger: 0.2,
        duration: 1,
        scrollTrigger: {
          trigger: ".tga1",
        },
      });
    }, tga1); // <- Scope!
    return () => ctx.revert(); // <- Cleanup!
  }, []);

  useLayoutEffect(() => {
    const ctx = gsap.context((self) => {
      gsap.from(".step-item", {
        opacity: 0,
        ease: "Power3.easeIn",
        y: 100,
        stagger: 0.2,
        duration: 1,
        scrollTrigger: {
          trigger: ".step-cont",
          scrub: 0.4,
        },
      });
    }, steps);
    return () => ctx.revert();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="home">
        {/*Popup*/}

        {/*Popup End*/}
        <Header />
        {/*Dynamic Text Section*/}
        <section className="ftco-section ftco-no-pt dyna-text">
          <div className="container position-relative">
            <div className="main-text">
              <span className="first-text">Mentoring and Coaching</span>
              <span className="first-text">
                OD interventions capacity building
              </span>
              <span className="first-text">
                Pure mentoring with real mentors
              </span>
              <span className="first-text">
                Brand Building and Social Media Management
              </span>
            </div>
            <div className="tagLine text-center mt-5">
              <span className="main-tag d-block" ref={tga1}>
                <span className="tga1">Develop.&nbsp;</span>
                <span className="tga1">Breakthrough.&nbsp;</span>
                <span className="tga1">Conquer.</span>
              </span>
              <span className="tagExp d-block mt-4 fw-bold">
                Where The Focus Is On You!
              </span>
            </div>
            <img
              src="assets/images/paper-plane-1.webp"
              alt="paper_plane"
              id="ball1"
              style={{ width: "200px", marginRight: "-60px" }}
            />
            <img src="assets/images/balloon_2.png" alt="balloon_2" id="ball2" />
          </div>
        </section>
        {/*Dynamic Text Section End*/}
        {/*Promo Banner*/}

        {/*Promo Banner End*/}

        {/* Coaching vs Mentoring */}
        <section className="ftco-section bg-light ftco-no-pt p-0">
          <div className="container-xl pt-5 mid-sect">
            <div className="top-text text-center">
              <h2 className="fw-bold text-light">
                Organisational Development | Mentoring and Coaching | Branding
                and Social Media Management
              </h2>
            </div>
            <div
              className="service-flex d-flex flex-lg-row flex-xl-row flex-column justify-content-center align-items-center flex-wrap gap-4 mt-5 row p-3"
              ref={service}
            >
              <div className="ser-item d-flex flex-column gap-4 text-center col-lg-3 col-xl-3 col-10 sia1">
                <div className="top-text-item" style={{ color: "#008dc7" }}>
                  OD Interventions
                </div>
                <div className="mid-icon-item">
                  <i className="fa-solid fa-chalkboard-user" />
                </div>
                <div className="bottom-text-item">
                  <p>
                    Growth doesn’t happen by chance. It starts with
                    self-awareness. And that’s where we come in. At Mentesquare,
                    we combine scientifically validated psychometric assessments
                    with practical, research-backed training interventions to
                    help both individuals and organizations understand how they
                    think, learn, lead, and grow.
                  </p>
                </div>
              </div>

              <div className="ser-item d-flex flex-column gap-4  text-center col-lg-3 col-xl-3 col-10 sia1">
                <div className="top-text-item" style={{ color: "#1a9856" }}>
                  Mentoring
                </div>
                <div className="mid-icon-item">
                  <i className="fa-solid fa-people-group" />
                </div>
                <div className="bottom-text-item">
                  <p>
                    The process of advising and training in order to develop
                    certain skills related to strategic thinking, required for
                    maximizing potential and performance. The mentors offer
                    advice and guidance based on their own experiences too.
                  </p>
                </div>
              </div>

              <div className="ser-item d-flex flex-column gap-4  text-center col-lg-3 col-xl-3 col-10 sia1">
                <div className="top-text-item" style={{ color: "#1bbfce" }}>
                  Branding
                </div>
                <div className="mid-icon-item">
                  <i className="fa-solid fa-bullhorn" />
                </div>
                <div className="bottom-text-item">
                  <p>
                    Whether you’re launching a start-up, nurturing an
                    entrepreneurial dream, or refining an existing brand, you
                    deserve more than just a logo—you deserve a brand that
                    speaks for you and your audience. At Mentesquare, we help
                    you build a distinct identity that’s thoughtful, strategic,
                    and unmistakably you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/*  Coaching vs Mentoring End  */}
        {/*Mentoring Process*/}
        <div className="mentoring-sect" id="mPro">
          <div className="mentoring-cont">
            <div className="mTop-text">
              <h2 className="fw-bold">Mentoring Process</h2>
              <h5 className="subheading fw-bold">Our 5 Simple Steps</h5>
            </div>
            <div className="step-flex" ref={steps}>
              <div className="step-cont d-flex w-100 justify-content-lg-start justify-content-xl-start justify-content-center">
                <div className="step-item d-flex justify-content-start">
                  <div className="step-img1" />
                  <div className="step-text p-4">
                    <h3 className="p-0 m-0 text-light fw-bold">
                      Step&nbsp;One
                    </h3>
                    <span className="p-0 m-0 text-light fw-bold">
                      Tell us about yourself
                    </span>
                  </div>
                </div>
              </div>
              <div className="step-cont d-flex w-100 justify-content-lg-end justify-content-xl-end justify-content-center">
                <div className="step-item d-flex justify-content-start">
                  <div className="step-img2" />
                  <div className="step-text p-4">
                    <h3 className="p-0 m-0 text-light fw-bold">
                      Step&nbsp;Two
                    </h3>
                    <span className="p-0 m-0 text-light fw-bold">
                      Have a free call with one of us to get all the info you
                      wish to know
                    </span>
                  </div>
                </div>
              </div>
              <div className="step-cont d-flex w-100 justify-content-lg-start justify-content-xl-start justify-content-center">
                <div className="step-item d-flex justify-content-start">
                  <div className="step-img3" />
                  <div className="step-text p-4">
                    <h3 className="p-0 m-0 text-light fw-bold">
                      Step&nbsp;Three
                    </h3>
                    <span className="p-0 m-0 text-light fw-bold">
                      Book a PEP Talk plan that suits your needs
                    </span>
                  </div>
                </div>
              </div>
              <div className="step-cont d-flex w-100 justify-content-lg-end justify-content-xl-end justify-content-center">
                <div className="step-item d-flex justify-content-start">
                  <div className="step-img4" />
                  <div className="step-text p-4">
                    <h3 className="p-0 m-0 text-light fw-bold">
                      Step&nbsp;Four
                    </h3>
                    <span className="p-0 m-0 text-light fw-bold">
                      Get started on the sessions with our Gyaan Guides
                    </span>
                  </div>
                </div>
              </div>
              <div className="step-cont d-flex w-100 justify-content-lg-start justify-content-xl-start justify-content-center">
                <div className="step-item d-flex justify-content-start">
                  <div className="step-img5" />
                  <div className="step-text p-4">
                    <h3 className="p-0 m-0 text-light fw-bold">
                      Step&nbsp;Five
                    </h3>
                    <span className="p-0 m-0 text-light fw-bold">
                      Grow and upskill as you go!
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Mentoring Process End*/}
        {/*  Pricing Section  */}
        <section class="ftco-section ftco-no-pt pricing-sect" id="prPack">
          <div class="container mt-5">
            <div class="row justify-content-center pb-5">
              <div class="col-md-7 text-center heading-section aos-init aos-animate">
                <h2 class="mb-3 pricing-text">
                  Mentoring &amp; Coaching <span>Packages</span>
                </h2>
              </div>
            </div>
            <div class="row justify-content-center align-items-center">
              <div class="col-12 text-center">
                <p class="fs-5 text-light fw-bold">
                  Individual, Group and Institutional pricing available on
                  request.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Video Section */}
        <section className="ftco-section ftco-no-pt bg-light py-5">
          <div className="container">
            <div className="row justify-content-center pb-4">
              <div className="col-md-8 text-center">
                <h2 className="mb-3 fw-bold" style={{ color: "#5b8e9f" }}>
                  Watch Our <span style={{ color: "#6dc1c1" }}>Story</span>
                </h2>
                <p className="fs-5 text-muted">
                  Get to know MenteSquare and our mission to help you develop, breakthrough, and conquer.
                </p>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-10 col-xl-8">
                <div 
                  className="video-container position-relative overflow-hidden rounded shadow-lg"
                  style={{
                    background: "linear-gradient(135deg, #5b8e9f 0%, #6dc1c1 100%)",
                    padding: "8px",
                    borderRadius: "20px"
                  }}
                >
                  <div className="ratio ratio-16x9">
                    <iframe
                      src="https://www.youtube.com/embed/GXL5UY8Yr9U"
                      title="MenteSquare Showreel"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      className="rounded"
                      style={{
                        borderRadius: "15px",
                        boxShadow: "0 10px 30px rgba(91, 142, 159, 0.3)"
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*  Pricing Section End  */}
        {/*Contact Section*/}
        <div className="contact-section">
          <div className="conHome-cont d-flex flex-lg-row flex-xl-row flex-md-row gap-lg-0 gap-xl-0 gap-4 flex-column align-items-center justify-content-around">
            <div className="top-text">
              <span className="fw-bold">Tell us about yourself</span>
              <p className="mt-4 fs-5 text-light fw-bold">
                You've taken the first step towards transforming yourself!
                Please take a few minutes to fill out this form to help us help
                you!
              </p>
            </div>
            <div className="contact-btn">
              <button
                className="btn shadow fw-bold fs-5 px-3 py-2"
                onClick={() => {
                  nav("/contact-us");
                }}
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
        {/*Contact Section End*/}
        {/*Testimonials*/}
        <div className="testimonials p-5" id="testm">
          <div className="testm-cont">
            <div className="test-top-text">
              <h2 className="fw-bold">Too good to be true?</h2>
            </div>
            <div className="testm-flex mt-5">
              <div className="row flex-wrap gap-4 justify-content-center">
                <div className="testm-item d-flex flex-column gap-3 col-lg-5 item">
                  <div className="ques-text">
                    <span>
                      As a BBA student, how can expert guidance help direct you
                      towards a fulfilling career path?
                    </span>
                  </div>
                  <div className="testm-text">
                    <span>
                      <i>
                        “A major issue that I have faced while pursuing my
                        interest in the field of management is that I stumbled a
                        lot of times in terms of where and how to go forward. I
                        believe expert guidance will help me find the answer to
                        those questions and it is better to walk down the path
                        with someone who already knows the way to your
                        destination.”{" "}
                      </i>
                    </span>
                  </div>
                  <div className="name-text">
                    <span>- Mohit, BBA Business Studies</span>
                  </div>
                </div>
                <div className="testm-item d-flex flex-column gap-3 col-lg-5 item">
                  <div className="ques-text">
                    <span>
                      As a fresher, how would expert guidance help you prepare
                      to work better in organizations in the future?
                    </span>
                  </div>
                  <div className="testm-text">
                    <span>
                      <i>
                        “Everyone would agree if I said adulting is anxious and
                        landing your first job and pretending to be
                        professionals is much more anxious. What if I said there
                        are mentors who can ease this process? How do they do
                        this? They normalize failure by experience sharing and
                        help us set attainable smart goals, all that we need for
                        our future organizations.”
                      </i>
                    </span>
                  </div>
                  <div className="name-text">
                    <span>- Amrutha, Psychology</span>
                  </div>
                </div>
              </div>
              <div className="viewMore d-flex w-100 px-5 mt-4 justify-content-end">
                <Link className="fw-bold shadow" to={"/testimonials"}>
                  View More...
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/*Testimonials End*/}
        {/*Our Team*/}
        <div className="ourTeam" id="ourTeam">
          <div className="ourTeam-cont">
            <div className="team-top-text">
              <h2 className="fw-bold">Our Team</h2>
            </div>
            <div className="team-cont mt-5 d-flex flex-column gap-5">
              <div className="team-card">
                <div className="team-item d-flex flex-lg-row flex-column gap-4 align-items-center">
                  <div className="imgDiv">
                    <img src="assets/images/anamika-v.jpg" alt="Team Member" />
                  </div>
                  <div className="team-text-div d-flex gap-3 flex-column">
                    <span className="fw-bold fs-1">Anamika Viswanathan</span>
                    <span className="fw-bold fs-5">Founder-Mentor</span>
                    <p className="fs-5 text-light">
                      Ms Anamika Viswanathan is a proficient and dynamic leader
                      with over three decades of international organizational
                      and leadership experience in Business Psychology and
                      Advertising. Having worked with premier advertising
                      agencies and trained as a Business Psychologist in the UK,
                      she relocated back to India and helped set up CAPS (Centre
                      for Academic and Professional Support) at CHRIST (Deemed
                      to be University)and served as the Consulting Head at
                      CHRIST (Deemed to be University), serving over 250+
                      clients across sectors by harnessing over 250+ faculty
                      members. She is the Founder Mentor at Mentesquare - a
                      platform that offers Executive Coaching, Mentoring,
                      Psychometric based L&D services and Branding and
                      Communication services. She is an accredited Lumina Spark
                      and Strengthscope practitioner, NLP coach and a member of
                      Association for Business Psychologists, UK. As a Leader,
                      Coach and Consultant, Anamika has hundreds of hours of
                      training experience across sectors. Her specialist areas
                      are Communication, English fluency, Impactful public
                      speaking skills, Cross-cultural communication, Team Design
                      for maximizing performance, Handling Stress and Mental
                      well-being and Personality Development.
                    </p>
                  </div>
                </div>
              </div>

              {/*<div className="team-card">*/}
              {/*    <div className="team-item2 d-flex flex-lg-row-reverse flex-column gap-3 align-items-center shadow">*/}
              {/*        <div className="imgDiv">*/}
              {/*            <img src="assets/images/darpan_team.jpg" alt="Team Member"/>*/}
              {/*        </div>*/}
              {/*        <div className="team-text-div d-flex gap-4 flex-column">*/}
              {/*            <span className="fw-bold fs-1">Darpan Sunil</span>*/}
              {/*            <span className="fw-bold fs-5">Business Development and Marketing Chief</span>*/}
              {/*            <p className="fs-5">Darpan Sunil is an avid marketer with the motto "over delivering value". He is a third-year BCom Honors student from CHRIST (Deemed to be University) and has a keen passion for the art of marketing and designing creative strategies.</p>*/}
              {/*        </div>*/}
              {/*    </div>*/}
              {/*</div>*/}
              {/*<div className="team-card">*/}
              {/*    <div className="team-item2 d-flex flex-lg-row flex-column gap-4 align-items-center shadow">*/}
              {/*        <div className="imgDiv">*/}
              {/*            <img src="assets/images/Srividyaa_team.jpg" alt="Team Member"/>*/}
              {/*        </div>*/}
              {/*        <div className="team-text-div d-flex gap-4 flex-column">*/}
              {/*            <span className="fw-bold fs-1">Srividyaa</span>*/}
              {/*            <span className="fw-bold fs-5">HR and Finance Chief</span>*/}
              {/*            <p className="fs-5">Srividyaa S is a BCom Honors graduate from CHRIST (Deemed to be University) and has completed her US CMA (Awaiting Charter). She is a meticulous worker with interests ranging from content writing and creative thinking to real-time bottle-neck solving.</p>*/}
              {/*        </div>*/}
              {/*    </div>*/}
              {/*</div>*/}
              {/*<div className="team-card">*/}
              {/*    <div className="team-item2 d-flex flex-lg-row-reverse flex-column gap-3 align-items-center shadow">*/}
              {/*        <div className="imgDiv">*/}
              {/*            <img src="assets/images/ansh_team.jpg" alt="Team Member"/>*/}
              {/*        </div>*/}
              {/*        <div className="team-text-div d-flex gap-4 flex-column">*/}
              {/*            <span className="fw-bold fs-1">Ansh Arora</span>*/}
              {/*            <span className="fw-bold fs-5">Tech Chief</span>*/}
              {/*            <p className="fs-5">Ansh Arora is a second-year BCA student from CHRIST (Deemed to be University) and a tech enthusiast with a keen interest developing new ideas for businesses as well as engineering – construction of models as well as deployment.</p>*/}
              {/*        </div>*/}
              {/*    </div>*/}
              {/*</div>*/}
            </div>
          </div>
        </div>
        {/*Our Team End*/}
        {/*Footer*/}
        <Footer />
        {/*Footer End*/}
      </div>
    </>
  );
};
